import { render, staticRenderFns } from "./DepartmentAdded.vue?vue&type=template&id=0f39242b&scoped=true"
import script from "./DepartmentAdded.vue?vue&type=script&lang=js"
export * from "./DepartmentAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f39242b",
  null
  
)

export default component.exports